import { Select } from 'antd';
import { useState } from 'react';
import { useSearchDataManagersQuery } from '@atlas-frontend/sdk';

export const DataManagerSelect = (props: {
  value?: string;
  onChange?: any;
}) => {
  const [search, setSearch] = useState('');
  const { data, isSuccess } = useSearchDataManagersQuery({ search });

  return (
    <Select
      id="dataManager"
      onSearch={setSearch}
      {...props}
      options={
        isSuccess
          ? data.map((user) => {
              return {
                value: user.username,
                label: `${user.username} - ${user.firstName} ${user.lastName}`,
              };
            })
          : []
      }
      showSearch
      allowClear
    />
  );
};
